export default __webpack_public_path__ + "static/media/JSCircularBackground-light-sepia-100px.ead757b1.jpg";